/* External dependencies */
import { gql } from '@apollo/client';

export const createWarehouseMutation = gql`
  mutation createWarehouse($input: CreateWarehouseInput!) {
    createWarehouse(input: $input) {
      id
      city
      country
      createdDate
      address
      phone
      postcode
      region
      status
      updatedDate
    }
  }
`;
